import { render, staticRenderFns } from "./DocumentShow.vue?vue&type=template&id=997d03ce&"
import script from "./DocumentShow.vue?vue&type=script&lang=js&"
export * from "./DocumentShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports